import { OPTION_SELECT } from './utils.constant';

export const EXPIRATION_DATE = 60;

export enum PageSize {
	XXXS = 3,
	XXS = 5,
	XS = 10,
	S = 20,
	M = 40,
	L = 60,
	XL = 80,
	XXL = 100,
}

export enum GenderEnum {
	MALE = 'MALE',
	FEMALE = 'FEMALE',
}

export enum GenderLabelEnum {
	MALE = '남자',
	FEMALE = '여자',
	MALE_AND_FEMALE = '남자와 여자',
}

export enum SortDirection {
	ASC = 'ASC',
	DESC = 'DESC',
}

export enum PageTypeEnum {
	DASHBOARD = 'DASHBOARD',
	USER = 'USER',
	UNIT = 'UNIT',
	PROGRAM = 'PROGRAM',
	FRANCHISE = 'FRANCHISE',
	FRANCHISE_NEW = 'FRANCHISE_NEW',
	RECOMMENDER = 'RECOMMENDER',
	APPLICANT = 'APPLICANT',
	FOREIGN_APPLICANT = 'FOREIGN_APPLICANT',
	LODGING = 'LODGING',
	EXTENSION_STAY = 'EXTENSION_STAY',
	CHANGE_WORK_PLACE = 'CHANGE_WORK_PLACE',
	UNAUTHORIZED_DEPARTURE = 'UNAUTHORIZED_DEPARTURE',
	NOTICE = 'NOTICE',
	INQUIRY_BOARD = 'INQUIRY_BOARD',
	INQUIRY_BOARD_ANSWER = 'INQUIRY_BOARD_ANSWER',
	ASSIGNMENT = 'ASSIGNMENT',
	FILE = 'FILE',
	APPLICANT_SALARY = 'APPLICANT_SALARY',
	ASSIGNMENT_FRANCHISE = 'ASSIGNMENT_FRANCHISE',
	ASSIGNMENT_APPLICANT = 'ASSIGNMENT_APPLICANT',
	EXTENSION_STAY_APPLICANT = 'EXTENSION_STAY_APPLICANT',
	PROGRAM_FOREIGN = 'PROGRAM_FOREIGN',
	USE_TIP = 'USE_TIP',
	PUBLIC_ASSIGNMENT = 'PUBLIC_ASSIGNMENT',
	PUBLIC_SALARY = 'PUBLIC_SALARY',
	FRANCHISE_PUBLIC = 'FRANCHISE_PUBLIC',
}

export enum UserSettingTypeEnum {
	LIST_FIELD_SETTINGS = 'LIST_FIELD_SETTINGS',
}

export enum UserSettingScreenCodeEnum {
	ED1 = 'ED1',
	UM1 = 'UM1',
	SM1 = 'SM1',
	CM1 = 'CM1',
	CM2 = 'CM2',
	MM1 = 'MM1',
	AR1 = 'AR1',
	FR1 = 'FR1',
	LM1 = 'LM1',
	AM1 = 'AM1',
	AM3 = 'AM3',
	EM1 = 'EM1',
	WC1 = 'WC1',
	BM1 = 'BM1',
	DM1 = 'DM1',
	PA1 = 'PA1',
	PA4 = 'PA4',
	PM1 = 'PM1',
	PM2 = 'PM2',
	RM1 = 'RM1',
	PA3 = 'PA3',
	OI1 = 'OI1',
	OI2 = 'OI2',
	OR1 = 'OR1',
	OP1 = 'OP1',
	FM1 = 'FM1',
	NM1 = 'NM1',
}

export enum UpdateFieldObjectNameEnum {
	USER = 'USER',
	UNIT = 'UNIT',
	FILE = 'FILE',
	FILE_MAPPING = 'FILE_MAPPING',
	UNIT_DISTRICT = 'UNIT_DISTRICT',
	UNIT_APPLICANT_STATUS = 'UNIT_APPLICANT_STATUS',
	UNIT_OPTIONAL_FIELD = 'UNIT_OPTIONAL_FIELD',
	APPLICANT = 'APPLICANT',
	FOREIGN_APPLICANT = 'FOREIGN_APPLICANT',
	APPLICANT_PROGRAM = 'APPLICANT_PROGRAM',
	FRANCHISE = 'FRANCHISE',
	ASSIGNMENT_FRANCHISE = 'ASSIGNMENT_FRANCHISE',
	ASSIGNMENT_APPLICANT = 'ASSIGNMENT_APPLICANT',
	LODGING = 'LODGING',
	FRANCHISE_PROGRAM = 'FRANCHISE_PROGRAM',
	PROGRAM = 'PROGRAM',
	EXTENSION_STAY = 'EXTENSION_STAY',
	EXTENSION_STAY_APPLICANT = 'EXTENSION_STAY_APPLICANT',
	CHANGE_WORK_PLACE = 'CHANGE_WORK_PLACE',
	UNAUTHORIZED_DEPARTURE = 'UNAUTHORIZED_DEPARTURE',
	APPLICANT_SALARY = 'APPLICANT_SALARY',
	NOTICE = 'NOTICE',
	INQUIRY_BOARD = 'INQUIRY_BOARD',
	INQUIRY_BOARD_ANSWER = 'INQUIRY_BOARD_ANSWER',
	RECOMMENDER = 'RECOMMENDER',
	DOCUMENT = 'DOCUMENT',
	FOOTER_INFO = 'WEB_INFO',
	USE_TIP = 'USE_TIP',
	PUBLIC_SALARY = 'PUBLIC_SALARY',
	UNIT_DISTRICT_ALLOW_IP = 'UNIT_DISTRICT_ALLOW_IP',
}

export enum UpdateFieldNameEnum {
	PUBLIC_FRANCHISE_ID = 'PUBLIC_FRANCHISE_ID',
	FULL_NAME = 'FULL_NAME',
	PASSWORD = 'PASSWORD',
	NAME = 'NAME',
	PHONE = 'PHONE',
	ROLE = 'ROLE',
	DEPARTMENT_NAME = 'DEPARTMENT_NAME',
	DISTRICT_ID = 'DISTRICT_ID',
	LATEST_LOGGED_IN_DT = 'LATEST_LOGGED_IN_DT',
	PUBLIC_MAIN_FRANCHISE_ID = 'PUBLIC_MAIN_FRANCHISE_ID',
	APPLICANT_ID = 'APPLICANT_ID',
	OCCURRING_AREA = 'OCCURRING_AREA',
	OCCURRING_AREA_DETAIL = 'OCCURRING_AREA_DETAIL',
	REASON = 'REASON',
	OCCURRING_DATE = 'OCCURRING_DATE',
	MEMO = 'MEMO',
	NEW_ASSIGNMENT_FRANCHISE_ID = 'NEW_ASSIGNMENT_FRANCHISE_ID',
	EXTENSION_PERIOD = 'EXTENSION_PERIOD',
	EXTENSION_DATE = 'EXTENSION_DATE',
	PROGRAM_ID = 'PROGRAM_ID',
	TYPE = 'TYPE',
	REQUEST_APPLICANT = 'REQUEST_APPLICANT',
	START_DATE = 'START_DATE',
	END_DATE = 'END_DATE',
	WORK_START_DATE = 'WORK_START_DATE',
	WORK_END_DATE = 'WORK_END_DATE',
	STATUS_ID = 'STATUS_ID',
	ENG_NAME = 'ENG_NAME',
	PROVIDER_NATIONAL_CODE = 'PROVIDER_NATIONAL_CODE',
	VISA_CODE = 'VISA_CODE',
	VISA_TIME = 'VISA_TIME',
	BIRTH_DATE = 'BIRTH_DATE',
	EMAIL = 'EMAIL',
	ADDRESS = 'ADDRESS',
	SPOUSE_TYPE = 'SPOUSE_TYPE',
	SPOUSE_NAME = 'SPOUSE_NAME',
	SPOUSE_PHONE = 'SPOUSE_PHONE',
	FRANCHISE_ID = 'FRANCHISE_ID',
	OWNERSHIP_TYPE = 'OWNERSHIP_TYPE',
	FACILITY_TYPE = 'FACILITY_TYPE',
	PROVIDED_DATE = 'PROVIDED_DATE',
	PROVIDER_TYPE = 'PROVIDER_TYPE',
	PROVIDER_NAME = 'PROVIDER_NAME',
	PROVIDER_PHONE = 'PROVIDER_PHONE',
	PROVIDER_ADDRESS = 'PROVIDER_ADDRESS',
	PROVIDER_ID = 'PROVIDER_ID',
	PROVIDER_TABLE = 'PROVIDER_TABLE',
	TYPE_DETAIL = 'TYPE_DETAIL',
	PRODUCTION_TYPE = 'PRODUCTION_TYPE',
	PRODUCTION_TYPE_DETAIL = 'PRODUCTION_TYPE_DETAIL',
	PRODUCTION_UNIT = 'PRODUCTION_UNIT',
	PRODUCTION_SCALE = 'PRODUCTION_SCALE',
	EMPLOYER_NAME = 'EMPLOYER_NAME',
	EMPLOYER_BIRTH_DATE = 'EMPLOYER_BIRTH_DATE',
	EMPLOYER_PHONE = 'EMPLOYER_PHONE',
	IS_PUBLIC = 'IS_PUBLIC',
	BUSINESS_REGIST_NO = 'BUSINESS_REGIST_NO',
	CORPORATE_REGIST_NO = 'CORPORATE_REGIST_NO',
	WORK_START_TIME = 'WORK_START_TIME',
	WORK_END_TIME = 'WORK_END_TIME',
	MONTHLY_WORKING_HOURS = 'MONTHLY_WORKING_HOURS',
	DAILY_BREAKS_NUMBER = 'DAILY_BREAKS_NUMBER',
	DAILY_BREAKS_HOUR = 'DAILY_BREAKS_HOUR',
	DAILY_BREAKS_MIN = 'DAILY_BREAKS_MIN',
	GRADE_A_DAILY_WAGE = 'GRADE_A_DAILY_WAGE',
	GRADE_B_DAILY_WAGE = 'GRADE_B_DAILY_WAGE',
	GRADE_C_DAILY_WAGE = 'GRADE_C_DAILY_WAGE',
	DEFAULT_GRADE = 'DEFAULT_GRADE',
	CUSTOM_FIELD1 = 'CUSTOM_FIELD1',
	CUSTOM_FIELD2 = 'CUSTOM_FIELD2',
	CUSTOM_FIELD3 = 'CUSTOM_FIELD3',
	CUSTOM_FIELD4 = 'CUSTOM_FIELD4',
	CUSTOM_FIELD5 = 'CUSTOM_FIELD5',
	FIRST_NAME = 'FIRST_NAME',
	LAST_NAME = 'LAST_NAME',
	GENDER = 'GENDER',
	HEIGHT = 'HEIGHT',
	WEIGHT = 'WEIGHT',
	HOMETOWN_ADDR = 'HOMETOWN_ADDR',
	HOMETOWN_PHONE = 'HOMETOWN_PHONE',
	NATIONAL_CODE = 'NATIONAL_CODE',
	PASSPORT_NO = 'PASSPORT_NO',
	PASSPORT_ISSUE_DATE = 'PASSPORT_ISSUE_DATE',
	PASSPORT_EXPIRE_DATE = 'PASSPORT_EXPIRE_DATE',
	APPLICATION_TYPE = 'APPLICATION_TYPE',
	IS_RE_ENTRY = 'IS_RE_ENTRY',
	RE_ENTRY_COUNT = 'RE_ENTRY_COUNT',
	GRADE = 'GRADE',
	ISSUANCE_STATUS_ID = 'ISSUANCE_STATUS_ID',
	VISA_ISSUANCE_CONFIRM_NO = 'VISA_ISSUANCE_CONFIRM_NO',
	VISA_NO = 'VISA_NO',
	FOREIGNER_NO = 'FOREIGNER_NO',
	ENTRY_DATE = 'ENTRY_DATE',
	DEPARTURE_DATE = 'DEPARTURE_DATE',
	EXPIRATION_DATE = 'EXPIRATION_DATE',
	CHANGE_WORK_DATE = 'CHANGE_WORK_DATE',
	UNAUTHORIZED_DEPARTURE_DATE = 'UNAUTHORIZED_DEPARTURE_DATE',
	EXTENSION_STAY_DATE = 'EXTENSION_STAY_DATE',
	RECOMMENDER_ID = 'RECOMMENDER_ID',
	RECOMMENDER_RELATIONSHIP = 'RECOMMENDER_RELATIONSHIP',
	LODGING_ID = 'LODGING_ID',
	LODGING_ARRANGEMENT_PENDING = 'LODGING_ARRANGEMENT_PENDING',
	ZIPCODE = 'ZIPCODE',
	ADDRESS_DETAIL = 'ADDRESS_DETAIL',
	COMPANY_SEAL_FILE_ID = 'COMPANY_SEAL_FILE_ID',
	SUB_DOMAIN = 'SUB_DOMAIN',
	MANAGER_NAME = 'MANAGER_NAME',
	MANAGER_PHONE = 'MANAGER_PHONE',
	NAME_PLATE_TITLE = 'NAME_PLATE_TITLE',
	NAME_PLATE_CONTENT = 'NAME_PLATE_CONTENT',
	TITLE = 'TITLE',
	CONTENT = 'CONTENT',
	TARGET_UNIT_ID = 'TARGET_UNIT_ID',
	START_DT = 'START_DT',
	END_DT = 'END_DT',
	DOCUMENT_TYPE = 'DOCUMENT_TYPE',
	JSON_CONTENT = 'JSON_CONTENT',
	CONTENTS = 'CONTENTS',
	ANSWER = 'ANSWER',
	INSPECTION_DATE = 'INSPECTION_DATE',
	CITY_PROVINCE = 'CITY_PROVINCE',
	COUNTY_DISTRICT = 'COUNTY_DISTRICT',
	CUSTOM_FIELD_1 = 'CUSTOM_FIELD_1',
	CUSTOM_FIELD_2 = 'CUSTOM_FIELD_2',
	PENALTY_POINTS_ACCUMULATED = 'PENALTY_POINTS_ACCUMULATED',
	IS_ALLOCATION_RESTRICTED = 'IS_ALLOCATION_RESTRICTED',
	SUB_TYPE = 'SUB_TYPE',
	MAX_MANPOWER_ALLOWED = 'MAX_MANPOWER_ALLOWED',
	IS_ACTIVATED_APPLICANT_NOTI = 'IS_ACTIVATED_APPLICANT_NOTI',
	IS_ACTIVATED_FRANCHISE_NOTI = 'IS_ACTIVATED_FRANCHISE_NOTI',
	IS_ACTIVATED_EXP_APPLICANT_SMS = 'IS_ACTIVATED_EXP_APPLICANT_SMS',
	IS_ACTIVATED_EXP_APPLICANT_NOTI = 'IS_ACTIVATED_EXP_APPLICANT_NOTI',
	UNIT_ID = 'UNIT_ID',
	FOREIGN_ADDRESS = 'FOREIGN_ADDRESS',
	DETAIL_REASON = 'DETAIL_REASON',
	ASSIGNMENT_DATE = 'ASSIGNMENT_DATE',
	OCCURING_AREA = 'OCCURING_AREA',
	OCCURING_AREA_DETAIL = 'OCCURING_AREA_DETAIL',
	OCCURING_DATE = 'OCCURING_DATE',
	MID_TERM_DEPARTURE = 'MID_TERM_DEPARTURE',
	RELAX_TIME = 'RELAX_TIME',
	START_TIME = 'START_TIME',
	END_TIME = 'END_TIME',
	LODGING_COST = 'LODGING_COST',
	MEAL_COST = 'MEAL_COST',
	IP_ADDRESS = 'IP_ADDRESS',
	IS_ACTIVE = 'IS_ACTIVE',
}

export enum UpdateHistoryRefTableNameEnum {
	USER = 'USER',
	UNIT = 'UNIT',
	FILE = 'FILE',
	FILE_MAPPING = 'FILE_MAPPING',
	UPDATE_HISTORY = 'UPDATE_HISTORY',
	UNIT_DISTRICT = 'UNIT_DISTRICT',
	UNIT_APPLICANT_STATUS = 'UNIT_APPLICANT_STATUS',
	UNIT_OPTIONAL_FIELD = 'UNIT_OPTIONAL_FIELD',
	APPLICANT = 'APPLICANT',
	APPLICANT_PROGRAM = 'APPLICANT_PROGRAM',
	FRANCHISE = 'FRANCHISE',
	ASSIGNMENT_FRANCHISE = 'ASSIGNMENT_FRANCHISE',
	PUBLIC_ASSIGNMENT_FRANCHISE = 'PUBLIC_ASSIGNMENT_FRANCHISE',
	ASSIGNMENT_APPLICANT = 'ASSIGNMENT_APPLICANT',
	LODGING = 'LODGING',
	FRANCHISE_PROGRAM = 'FRANCHISE_PROGRAM',
	PROGRAM = 'PROGRAM',
	EMAIL = 'EMAIL',
	EXTENSION_STAY = 'EXTENSION_STAY',
	EXTENSION_STAY_APPLICANT = 'EXTENSION_STAY_APPLICANT',
	CHANGE_WORK_PLACE = 'CHANGE_WORK_PLACE',
	UNAUTHORIZED_DEPARTURE = 'UNAUTHORIZED_DEPARTURE',
	APPLICANT_SALARY = 'APPLICANT_SALARY',
	NOTICE = 'NOTICE',
	INQUIRY_BOARD = 'INQUIRY_BOARD',
	RECOMMENDER = 'RECOMMENDER',
	APPLICANT_PROCESSING = 'APPLICANT_PROCESSING',
	FOREIGN_UNIT = 'FOREIGN_UNIT',
	WORKER_PROGRAM = 'WORKER_PROGRAM',
}

export enum MasterInfoEnum {
	UNIT = 'UNIT',
	PROGRAM = 'PROGRAM',
	PROGRAM_OF_FOREIGN = 'PROGRAM_OF_FOREIGN',
	FOREIGN_PROGRAM_LIST = 'FOREIGN_PROGRAM_LIST',
	DISTRICT = 'DISTRICT',
	PUBLIC_FRANCHISE_AGRICULTURE = 'PUBLIC_FRANCHISE_AGRICULTURE',
	ALL_CONTENT = 'ALL_CONTENT',
	BASIC_INFO_APPLICANT = 'BASIC_INFO_APPLICANT',
	FRANCHISE = 'FRANCHISE',
	RECOMMENDER = 'RECOMMENDER',
	AUTOCOMPLETE_FRANCHISE_NAME = 'AUTOCOMPLETE_FRANCHISE_NAME',
	AUTOCOMPLETE_APPLICANT_NAME = 'AUTOCOMPLETE_APPLICANT_NAME',
	AUTOCOMPLETE_RECOMMENDER_NAME = 'AUTOCOMPLETE_RECOMMENDER_NAME',
	AUTOCOMPLETE_FRANCHISE = 'AUTOCOMPLETE_FRANCHISE',
	AUTOCOMPLETE_RECOMMENDER = 'AUTOCOMPLETE_RECOMMENDER',
	APPLICANT = 'APPLICANT',
	NATIONAL = 'NATIONAL',
	AUTOCOMPLETE_FRANCHISE_EMPLOYER_NAME = 'AUTOCOMPLETE_FRANCHISE_EMPLOYER_NAME',
	ASSIGNMENT_APPLICANT = 'ASSIGNMENT_APPLICANT',
	APPLICANT_BY_FRANCHISE = 'APPLICANT_BY_FRANCHISE',
	APPLICANT_BY_PROGRAM = 'APPLICANT_BY_PROGRAM',
	APPLICANT_BY_RECOMMENDER = 'APPLICANT_BY_RECOMMENDER',
	APPLICANT_BY_LODGING = 'APPLICANT_BY_LODGING',
	LODGING = 'LODGING',
	COMMON_LODGING = 'COMMON_LODGING',
	AUTOCOMPLETE_RECRUITER = 'AUTOCOMPLETE_RECRUITER',
	WC_FRANCHISE_NEW = 'WC_FRANCHISE_NEW',
	WC_FRANCHISE_ASSIGNMENT = 'WC_FRANCHISE_ASSIGNMENT',
	PROVIDER_LODGING = 'PROVIDER_LODGING',
	AUTOCOMPLETE_PROVIDER_NAME = 'AUTOCOMPLETE_PROVIDER_NAME',
	AUTOCOMPLETE_ADDRESS = 'AUTOCOMPLETE_ADDRESS',
	COMMON_APPLICANT = 'COMMON_APPLICANT',
	COMMON_ASSIGNMENT_AUTO = 'COMMON_ASSIGNMENT_AUTO',
	COMMON_RECOMMENDER = 'COMMON_RECOMMENDER',
	FRANCHISE_DROPDOWN = 'FRANCHISE_DROPDOWN',
	AUTO_COMPLETE_MANAGER_NAME = 'AUTO_COMPLETE_MANAGER_NAME',
	UNAUTHORIZED_DEPARTURE_APPLICANT = 'UNAUTHORIZED_DEPARTURE_APPLICANT',
	FRANCHISE_APPLICANT_TO_ASSIGNED = 'FRANCHISE_APPLICANT_TO_ASSIGNED',
	APPLICANT_SALARY_AUTOCOMPLETE_APPLICANT_NAME = 'APPLICANT_SALARY_AUTOCOMPLETE_APPLICANT_NAME',
	APPLICANT_SALARY_AUTOCOMPLETE_EMPLOYEE_NAME = 'APPLICANT_SALARY_AUTOCOMPLETE_EMPLOYEE_NAME',
	RECOMMENDER_FRANCHISE = 'RECOMMENDER_FRANCHISE',
	COMMON_POPUP_LODGING = 'COMMON_POPUP_LODGING',
	FOREIGN_DOMESTIC_UNIT = 'FOREIGN_DOMESTIC_UNIT',
	FOREIGN_BUSINESS_UNIT = 'FOREIGN_BUSINESS_UNIT',
	COMMON_TARGET_UNIT = 'COMMON_TARGET_UNIT',
	AUTOCOMPLETE_QUESTIONER = 'AUTOCOMPLETE_QUESTIONER',
	DOMESTIC_UNIT_DROPDOWN = 'DOMESTIC_UNIT_DROPDOWN',
	COMMON_NOTICE_RECEIVE_REGISTER_UNIT = 'COMMON_NOTICE_RECEIVE_REGISTER_UNIT',
	COMMON_UNIT_DOMESTIC_REGISTER_LIST = 'COMMON_UNIT_DOMESTIC_REGISTER_LIST',
	COMMON_DISTRICT_VALIDATOR = 'COMMON_DISTRICT_VALIDATOR',
	PUBLIC_FRANCHISE_EMPLOYER_NAME = 'PUBLIC_FRANCHISE_EMPLOYER_NAME',
	USER_AUTOCOMPLETE_SUGGESTIONS = 'USER_AUTOCOMPLETE_SUGGESTIONS',
	DEVICE_LOG_ADMIN_SUGGESTIONS = 'DEVICE_LOG_ADMIN_SUGGESTIONS',
}

export enum ApplicantStatusEnum {
	STATUS = 'STATUS',
	ISSUANCE_APPLICATION_STATUS = 'ISSUANCE_APPLICATION_STATUS',
}

export enum ApplicantTypeEnum {
	DOMESTIC_STAY = 'DOMESTIC_STAY',
	FAMILY_RELATIVES = 'FAMILY_RELATIVES',
	MOU_FOREIGN_WORKERS = 'MOU_FOREIGN_WORKERS',
	REENTRY_RECOMMENDATION = 'REENTRY_RECOMMENDATION',
	D2_STUDENT_PARENT_INVITATION = 'D2_STUDENT_PARENT_INVITATION',
}

export enum ApplicantTableStatusTypeEnum {
	WAITING_ENTRY = 'WAITING_ENTRY',
	COMPLETE_ENTRY = 'COMPLETE_ENTRY',
	STARTING_WORK = 'STARTING_WORK',
	FINISH_WORK = 'FINISH_WORK',
	QUITTING_WORK = 'QUITTING_WORK',
	DEPARTING = 'DEPARTING',
	//todo custom status option
}

export enum ApplicantTableStatusNameEnum {
	WAITING_ENTRY = '입국대기',
	COMPLETE_ENTRY = '입국완료',
	STARTING_WORK = '근무중',
	FINISH_WORK = '근무 종료',
	QUITTING_WORK = '무단이탈',
	DEPARTING = '출국',
	//todo custom status option
}

export enum PublicTypeEnum {
	A = 'A',
	B = 'B',
	C = 'C',
	DEFAULT = '기본 등급',
}
export enum Ownership {
	SELF = 'SELF',
	LEASE = 'LEASE',
	OTHER = 'OTHER',
}

export enum Infrastructure {
	PRIVATE_HOUSE = 'PRIVATE_HOUSE',
	PREFABRICATED_HOUSING_FACILITY = 'PREFABRICATED_HOUSING_FACILITY',
	ACCOMMODATION = 'ACCOMMODATION',
	DORMITORY = 'DORMITORY',
	OTHER = 'OTHER',
}

export enum ExcelBatchOperationEnum {
	DOWNLOAD_APPLICANT_LIST = 'DOWNLOAD_APPLICANT_LIST',
	UPLOAD_APPLICANT_LIST = 'UPLOAD_APPLICANT_LIST',

	DOWNLOAD_FRANCHISE_LIST = 'DOWNLOAD_FRANCHISE_LIST',
	UPLOAD_FRANCHISE_LIST = 'UPLOAD_FRANCHISE_LIST',

	DOWNLOAD_RECOMMENDER_LIST = 'DOWNLOAD_RECOMMENDER_LIST',
	UPLOAD_RECOMMENDER_LIST = 'UPLOAD_RECOMMENDER_LIST',

	DOWNLOAD_LODGING_LIST = 'DOWNLOAD_LODGING_LIST',
	UPLOAD_LODGING_LIST = 'UPLOAD_LODGING_LIST',

	DOWNLOAD_ASSIGNMENT_LIST = 'DOWNLOAD_ASSIGNMENT_LIST',
	UPLOAD_ASSIGNMENT_LIST = 'UPLOAD_ASSIGNMENT_LIST',

	DOWNLOAD_PROGRAM_LIST = 'DOWNLOAD_PROGRAM_LIST',

	DOWNLOAD_EXTENSION_STAY_LIST = 'DOWNLOAD_EXTENSION_STAY_LIST',

	DOWNLOAD_PAYROLL = 'DOWNLOAD_PAYROLL',
	DOWNLOAD_UNAUTHORIZED_DEPARTURE = 'DOWNLOAD_UNAUTHORIZED_DEPARTURE',

	DOWNLOAD_WORK_CHANGE_LIST = 'DOWNLOAD_WORK_CHANGE_LIST',

	DOWNLOAD_PUBLIC_ASSIGNMENT_LIST = 'DOWNLOAD_PUBLIC_ASSIGNMENT_LIST',
	UPLOAD_PUBLIC_ASSIGNMENT_LIST = 'UPLOAD_PUBLIC_ASSIGNMENT_LIST',

	DOWNLOAD_PUBLIC_SALARY_LIST = 'DOWNLOAD_PUBLIC_SALARY_LIST',
}

export enum TimeOptionEnum {
	TODAY = 'today',
	THIS_WEEK = 'thisWeek',
	THIS_MONTH = 'thisMonth',
	THIS_YEAR = 'thisYear',
}

export enum StatusApplicationEnum {
	BEFORE_APPLY_VISA = 'BEFORE_APPLY_VISA',
	REVIEW_VISA = 'REVIEW_VISA',
	ISSUE_VISA = 'ISSUE_VISA ',
	BEFORE_APPLY_FOREIGN_CARD = 'BEFORE_APPLY_FOREIGN_CARD',
	REVIEW_FOREIGN_CARD = 'REVIEW_FOREIGN_CARD',
	ISSUE_FOREIGN_CARD = 'ISSUE_FOREIGN_CARD',
	BEFORE_APPLY_RESIDENCE = 'BEFORE_APPLY_RESIDENCE',
	REVIEW_APPLY_RESIDENCE = 'REVIEW_APPLY_RESIDENCE',
	GRANTING_RESIDENCE = 'GRANTING_RESIDENCE',
}

export enum StatusApplicationNameEnum {
	BEFORE_APPLY_VISA = '사증인증번호 신청전',
	REVIEW_VISA = '사증인증번호 심사중',
	ISSUE_VISA = '사증인증번호 발급',
	BEFORE_APPLY_FOREIGN_CARD = '외국인등록증 신청전',
	REVIEW_FOREIGN_CARD = '외국인등록증 심사중',
	ISSUE_FOREIGN_CARD = '외국인등록증 발급',
	BEFORE_APPLY_RESIDENCE = '체류연장 신청전',
	REVIEW_APPLY_RESIDENCE = '체류연장 심사중',
	GRANTING_RESIDENCE = '체류연장 발급',
}
export enum ResidenceEnum {
	C4 = 'C_4',
	C41 = 'C_4_1',
	C42 = 'C_4_2',
	C43 = 'C_4_3',
	C44 = 'C_4_4',
	E8 = 'E_8',
	E81 = 'E_8_1',
	E82 = 'E_8_2',
	E83 = 'E_8_3',
	E84 = 'E_8_4',
	E85 = 'E_8_5',
	E86 = 'E_8_6',
	E899 = 'E_8_99',
}

export const ResidenceLabel = {
	[ResidenceEnum.E8]: 'E-8',
	[ResidenceEnum.E81]: 'E-8-1',
	[ResidenceEnum.E82]: 'E-8-2',
	[ResidenceEnum.E83]: 'E-8-3',
	[ResidenceEnum.E84]: 'E-8-4',
	[ResidenceEnum.E85]: 'E-8-5',
	[ResidenceEnum.E86]: 'E-8-6',
	[ResidenceEnum.E899]: 'E-8-99',
	[ResidenceEnum.C4]: 'C-4',
	[ResidenceEnum.C41]: 'C-4-1',
	[ResidenceEnum.C42]: 'C-4-2',
	[ResidenceEnum.C43]: 'C-4-3',
	[ResidenceEnum.C44]: 'C-4-4',
};

export enum ContentProcessInfoEnum {
	EXTENSION_STAY = 'EXTENSION_STAY',
	CHANGE_WORK_PLACE = 'CHANGE_WORK_PLACE',
	UNAUTHORIZED_DEPARTURE = 'UNAUTHORIZED_DEPARTURE',
}

export enum BusinessType {
	AGRICULTURAL = 'AGRICULTURE',
	FISHING = 'FISHING',
}

export enum ResidenceTypeEnum {
	F_6 = 'F_6',
	F_5 = 'F_5',
	F_6_1 = 'F_6_1',
	F_6_2 = 'F_6_2',
	F_6_3 = 'F_6_3',
}

export enum AgriFranchiseEnum {
	AGRICULTURAL_BUSINESS_HOUSEHOLD = 'AGRICULTURAL_MANAGEMENT_HOUSEHOLDS',
	AGRICULTURAL_CORPORATION_ASSOCIATION = 'AGRICULTURAL_CORPORATIONS_ASSOCIATIONS',
	AGRICULTURAL_PRODUCT_PROCESSING_COMPANY = 'AGRICULTURAL_PROCESSING_COMPANIES',
	PUBLIC_FRANCHISE = 'PUBLIC_BUSINESS_ENTITIES',
}

export enum FisheryFranchiseEnum {
	FISHING_OPERATION_HOUSEHOLD = 'FISHERY_MANAGEMENT_HOUSEHOLDS',
	FISHING_CORPORATION_ASSOCIATION = 'FISHERY_ASSOCIATIONS_CORPORATIONS',
	FISHING_PRODUCT_PROCESSING_COMPANY = 'FISHERY_PROCESSING_COMPANIES',
	PUBLIC_FRANCHISE = 'PUBLIC_BUSINESS_ENTITIES',
}

export enum ProductionTypeEnum {
	HORTICULTURE_SPECIAL_CROPS = 'HORTICULTURE_SPECIAL_CROPS',
	MUSHROOMS = 'MUSHROOMS',
	FRUITS = 'FRUITS',
	GINSENG_AND_GENERAL_VEGETABLES = 'GINSENG_AND_GENERAL_VEGETABLES',
	BEAN_SPROUTS_AND_SEEDLING_CULTIVATION = 'BEAN_SPROUTS_AND_SEEDLING_CULTIVATION',
	OTHER_HORTICULTURE_SPECIAL_CROPS = 'OTHER_HORTICULTURE_SPECIAL_CROPS',
	GRAINS = 'GRAINS',
	OTHER_FOOD_CROPS = 'OTHER_FOOD_CROPS',
	DRIED_PERSIMMON_PROCESSING = 'DRIED_PERSIMMON_PROCESSING',
	SEAWEED_DRY_LAVER = 'SEAWEED_DRY_LAVER',
	SEAWEED_OTHER = 'SEAWEED_OTHER',
	SEAWEED_AQUACULTURE = 'SEAWEED_AQUACULTURE',
	SHELLFISH_DRY_ANCHOVIES = 'SHELLFISH_DRY_ANCHOVIES',
	SHELLFISH_OTHER = 'SHELLFISH_OTHER',
	SHELLFISH_ABALONE_SEED = 'SHELLFISH_ABALONE_SEED',
	SHELLFISH_AQUACULTURE = 'SHELLFISH_AQUACULTURE',
	TUNICATES_AQUACULTURE = 'TUNICATES_AQUACULTURE',
}

export const PRODUCTION_TYPE_AGRICULTURE_OPTIONS = [
	{
		value: ProductionTypeEnum.HORTICULTURE_SPECIAL_CROPS,
		label: '시설 원예·특작',
	},
	{
		value: ProductionTypeEnum.MUSHROOMS,
		label: '버섯',
	},
	{
		value: ProductionTypeEnum.FRUITS,
		label: '과수',
	},
	{
		value: ProductionTypeEnum.GINSENG_AND_GENERAL_VEGETABLES,
		label: '인삼, 일반채소',
	},
	{
		value: ProductionTypeEnum.BEAN_SPROUTS_AND_SEEDLING_CULTIVATION,
		label: '콩나물, 종묘재배',
	},
	{
		value: ProductionTypeEnum.OTHER_HORTICULTURE_SPECIAL_CROPS,
		label: '기타원예·특작',
	},
	{
		value: ProductionTypeEnum.GRAINS,
		label: '곡물',
	},
	{
		value: ProductionTypeEnum.OTHER_FOOD_CROPS,
		label: '기타 식량작물',
	},
	{
		value: ProductionTypeEnum.DRIED_PERSIMMON_PROCESSING,
		label: '곶감 가공',
	},
];

export const PRODUCTION_TYPE_FISHING_OPTIONS = [
	{
		value: ProductionTypeEnum.SEAWEED_DRY_LAVER,
		label: '해조류(마른김)',
	},
	{
		value: ProductionTypeEnum.SEAWEED_OTHER,
		label: '해조류(기타)',
	},
	{
		value: ProductionTypeEnum.SEAWEED_AQUACULTURE,
		label: '해조류(양식)',
	},
	{
		value: ProductionTypeEnum.SHELLFISH_DRY_ANCHOVIES,
		label: '어패류(멸치 건조)',
	},
	{
		value: ProductionTypeEnum.SHELLFISH_OTHER,
		label: '어패류(기타)',
	},
	{
		value: ProductionTypeEnum.SHELLFISH_ABALONE_SEED,
		label: '어패류(전복종자)',
	},
	{
		value: ProductionTypeEnum.SHELLFISH_AQUACULTURE,
		label: '어패류(양식)',
	},
	{
		value: ProductionTypeEnum.TUNICATES_AQUACULTURE,
		label: '피낭류(양식)',
	},
];

export enum ProductionUnitEnum {
	SQUARE_METER = 'SQUARE_METER',
	FOLD = 'FOLD',
	INSIDE = 'INSIDE',
	TON = 'TON',
	BOX = 'BOX',
	ANIMAL = 'ANIMAL',
}

export const PRODUCTION_UNIT_AGRICULTURE_OPTIONS = [
	{
		value: ProductionUnitEnum.SQUARE_METER,
		label: '1,000㎡',
	},
];

export const PRODUCTION_UNIT_FISHING_OPTIONS = [
	{
		value: ProductionUnitEnum.FOLD,
		label: '접',
	},
	{
		value: ProductionUnitEnum.INSIDE,
		label: '속',
	},
	{
		value: ProductionUnitEnum.TON,
		label: '톤',
	},
	{
		value: ProductionUnitEnum.BOX,
		label: '박스',
	},
	{
		value: ProductionUnitEnum.ANIMAL,
		label: '마리',
	},
];

export enum EmploymentTypeEnum {
	MOU_FOREIGN_WORKER = 'MOU_FOREIGN_WORKER',
	MARRIAGE_IMMIGRANT_RELATIVE = 'MARRIAGE_IMMIGRANT_RELATIVE',
}

export enum RelationshipEnum {
	FAMILY = 'FAMILY',
	FRANCHISE = 'FRANCHISE',
	OTHER = 'OTHER',
}

export enum OpenFromEnum {
	LM1_03 = 'LM1_03',
	RM1_03 = 'RM1_03',
	BM1_03 = 'BM1_03',
	PM1_03 = 'PM1_03',
}

export enum DocTypeEnum {
	WC1_05 = 'C_60',
	WC1_13 = 'C_61',
	WC1_07 = 'C_62',
	AM1_05 = 'C_48',
	AM1_06 = 'C_55',
	AM1_08 = 'C_13',
	AM1_09 = 'C_49',
	ES1_09 = 'C_19',
	ES1_10 = 'C_57',
	PM1_09 = 'C_37',
	PM1_10 = 'C_54',
	PM2_22 = 'C_25',
	PM1_19 = 'C_38',
	PM2_23 = 'C_52',
	PM2_24 = 'C_53',
	ES1_08 = 'C_59',
	PM1_13 = 'C_18',
	PM1_04 = 'C_3',
	AFR_04 = 'C_67',
	AFR_05 = 'C_68',
	AFR_07 = 'C_42',
	FRF_04 = 'C_24',
	FRF_08 = 'C_69',
	FRF_09 = 'C_73',
	FRF_10 = 'C_65',
	FRF_11 = 'C_66',
	PMF_02 = 'C_4',
	LMF_04 = 'C_16',
	WCF_02 = 'C_58',
	ARF_08 = 'C_72',
	ARF_09 = 'C_74',
	ARF_10 = 'C_77',
	FRF_12 = 'C_76',
	// New Form
	ARF_11 = 'C_78',
	ARF_12 = 'C_79',
	ARF_13 = 'C_81',
	FRF_13 = 'C_80',
	ARF_14 = 'C_82',
	ARF_15 = 'C_83',
	ARF_16 = 'C_84',
}

export enum DivisionRecommenderEnum {
	MARRIAGE_IMMIGRANT = 'MARRIAGE_IMMIGRANT',
	OVERSEAS_LOCAL_GOVERNMENT = 'OVERSEAS_LOCAL_GOVERNMENT',
}

export enum GradeEnum {
	BASIC_GRADE = 'BASIC_GRADE',
	GRADE_A = 'GRADE_A',
	GRADE_B = 'GRADE_B',
	GRADE_C = 'GRADE_C',
}

export const FRANCHISE_GRADE_OPTIONS = [
	{
		value: GradeEnum.GRADE_A,
		label: 'A',
	},
	{
		value: GradeEnum.GRADE_B,
		label: 'B',
	},
	{
		value: GradeEnum.GRADE_C,
		label: 'C',
	},
];

export const GRADE_OPTIONS = [
	{
		value: GradeEnum.GRADE_A,
		label: 'level-a',
	},
	{
		value: GradeEnum.GRADE_B,
		label: 'level-b',
	},
	{
		value: GradeEnum.GRADE_C,
		label: 'level-c',
	},
	{
		value: GradeEnum.BASIC_GRADE,
		label: 'basic-level',
	},
];

export enum UnitTypeEnum {
	COUNTRY_OR_AUTONOMOUS_REGION = 'COUNTRY_OR_AUTONOMOUS_REGION',
	CORPORATION = 'CORPORATION',
	INDIVIDUAL = 'INDIVIDUAL',
}

export const UNIT_TYPES = [
	{
		value: UnitTypeEnum.COUNTRY_OR_AUTONOMOUS_REGION,
		label: 'country-or-autonomous-region',
	},
	{
		value: UnitTypeEnum.CORPORATION,
		label: 'corporation',
	},
	{
		value: UnitTypeEnum.INDIVIDUAL,
		label: 'individual',
	},
];

export const TIME_OPTIONS = [
	{
		value: '',
		label: 'filter-date.select-period',
	},
	{
		value: TimeOptionEnum.TODAY,
		label: 'filter-date.today',
	},
	{
		value: TimeOptionEnum.THIS_WEEK,
		label: 'filter-date.week',
	},
	{
		value: TimeOptionEnum.THIS_MONTH,
		label: 'filter-date.month',
	},
	{
		value: TimeOptionEnum.THIS_YEAR,
		label: 'filter-date.year',
	},
];

export const GENDER_OPTION = [
	{
		value: '',
		label: 'select',
	},
	{
		value: GenderEnum.MALE,
		label: 'male',
	},
	{
		value: GenderEnum.FEMALE,
		label: 'female',
	},
];

export const APPLICANT_TYPE_OPTION = [
	{
		value: '',
		label: 'select',
	},
	{
		value: ApplicantTypeEnum.MOU_FOREIGN_WORKERS,
		label: 'mou-foreign-workers',
	},
	{
		value: ApplicantTypeEnum.FAMILY_RELATIVES,
		label: 'family-relatives',
	},
	{
		value: ApplicantTypeEnum.DOMESTIC_STAY,
		label: 'domestic-stay',
	},
	{
		value: ApplicantTypeEnum.D2_STUDENT_PARENT_INVITATION,
		label: 'd2-student-parent-invitation',
	},
];

export const STATUS_TYPE_OPTION = [
	{
		value: '',
		label: 'select',
	},
	{
		value: ApplicantTableStatusNameEnum.WAITING_ENTRY,
		label: 'status-type-options-waiting-entry',
	},
	{
		value: ApplicantTableStatusNameEnum.COMPLETE_ENTRY,
		label: 'status-type-options-entry-completed',
	},
	{
		value: ApplicantTableStatusNameEnum.STARTING_WORK,
		label: 'status-type-options-on-duty',
	},
	{
		value: ApplicantTableStatusNameEnum.FINISH_WORK,
		label: 'status-type-options-duty-completed',
	},
	{
		value: ApplicantTableStatusNameEnum.QUITTING_WORK,
		label: 'status-type-options-unauthorized-absence',
	},
	{
		value: ApplicantTableStatusNameEnum.DEPARTING,
		label: 'status-type-options-departure',
	},
];

export const STATUS_APPLICATION_TYPE_OPTION = [
	{
		value: '',
		label: 'select',
	},
	{
		value: StatusApplicationNameEnum.BEFORE_APPLY_VISA,
		label: 'status-application-type-options-before-apply-visa',
	},
	{
		value: StatusApplicationNameEnum.REVIEW_VISA,
		label: 'status-application-type-options-review-visa',
	},
	{
		value: StatusApplicationNameEnum.ISSUE_VISA,
		label: 'status-application-type-options-issue-visa',
	},
	{
		value: StatusApplicationNameEnum.BEFORE_APPLY_FOREIGN_CARD,
		label: 'status-application-type-options-before-apply-foreign-card',
	},
	{
		value: StatusApplicationNameEnum.REVIEW_FOREIGN_CARD,
		label: 'status-application-type-options-review-foreign-card',
	},
	{
		value: StatusApplicationNameEnum.ISSUE_FOREIGN_CARD,
		label: 'status-application-type-options-issue-foreign-card',
	},
	{
		value: StatusApplicationNameEnum.BEFORE_APPLY_RESIDENCE,
		label: 'status-application-type-options-before-apply-residence',
	},
	{
		value: StatusApplicationNameEnum.REVIEW_APPLY_RESIDENCE,
		label: 'status-application-type-options-review-apply-residence',
	},
	{
		value: StatusApplicationNameEnum.GRANTING_RESIDENCE,
		label: 'status-application-type-options-granting-residence',
	},
];
export enum Provider {
	FRANCHISE = 'FRANCHISE',
	RECOMMENDER = 'RECOMMENDER',
	LODGING = 'LODGING',
	APPLICANT = 'APPLICANT',
	OTHER = 'OTHER',
}

export const PROVIDERS_LODGING_OPTIONS = [
	{
		value: Provider.FRANCHISE,
		label: '고용주',
	},
	{
		value: Provider.RECOMMENDER,
		label: '추천자',
	},
];

export const PROVIDERS_RECOMMENDER_OPTIONS = [
	{
		value: Provider.FRANCHISE,
		label: '고용주',
	},
];

export const PROVIDERS_TYPE_LODGING_OPTIONS = [
	{
		value: Provider.FRANCHISE,
		label: '고용주',
		providerTable: Provider.FRANCHISE,
	},
	{
		value: Provider.RECOMMENDER,
		label: '추천자',
		providerTable: Provider.RECOMMENDER,
	},
	{
		value: Provider.OTHER,
		label: '기타',
		providerTable: Provider.OTHER,
	},
];

export const PROVIDERS_APPLICANT = [
	{
		value: Provider.FRANCHISE,
		label: '고용주',
	},
	{
		value: Provider.RECOMMENDER,
		label: '추천자',
	},
	{
		value: Provider.LODGING,
		label: '숙소',
	},
];

export const PROVIDER_OPTIONS = [OPTION_SELECT, ...PROVIDERS_LODGING_OPTIONS];

export enum RecommenderProviderTypeEnum {
	ID = 'ID',
	RECOMMEND_NAME = 'RECOMMEND_NAME',
	RECOMMEND_PHONE = 'RECOMMEND_PHONE',
}

export const RECOMMENDER_OPTIONS = [
	{
		value: RecommenderProviderTypeEnum.ID,
		label: 'ID',
	},
	{
		value: RecommenderProviderTypeEnum.RECOMMEND_NAME,
		label: '추천자',
		type: MasterInfoEnum.AUTOCOMPLETE_RECOMMENDER,
	},
	{
		value: RecommenderProviderTypeEnum.RECOMMEND_PHONE,
		label: '추천자 전화번호',
	},
];

export const CONTENT_PROCESS_INFO_OPTION = [
	{
		value: '',
		label: '내용 전체',
	},
	// {
	// 	value: ContentProcessInfoEnum.EXTENSION_STAY,
	// 	label: '체류연장',
	// },
	{
		value: ContentProcessInfoEnum.CHANGE_WORK_PLACE,
		label: '근무처변경',
	},
	{
		value: ContentProcessInfoEnum.UNAUTHORIZED_DEPARTURE,
		label: '무단이탈',
	},
];

export const VISA_CODE_OPTION = [
	{
		value: '',
		label: '선택',
	},
	...Object.entries(ResidenceLabel).map(([key, value]) => ({
		value: key,
		label: value,
	})),
];

export const VISA_CODE_OPTION_MOBILE = [
	{
		value: '',
		label: '선택',
	},
	...Object.entries(ResidenceLabel).map(([key, value]) => ({
		value: key,
		label: value,
	})),
];

export const OWNERSHIP_OPTIONS = [
	{
		value: Ownership.SELF,
		label: '자가',
	},
	{
		value: Ownership.LEASE,
		label: '임대',
	},
	{
		value: Ownership.OTHER,
		label: '기타',
	},
];

export const INFRASTRUCTURE_OPTIONS = [
	{
		value: Infrastructure.PRIVATE_HOUSE,
		label: '개인 주택',
	},
	{
		value: Infrastructure.PREFABRICATED_HOUSING_FACILITY,
		label: '조립식주거시설',
	},
	{
		value: Infrastructure.ACCOMMODATION,
		label: '숙박시설',
	},
	{
		value: Infrastructure.DORMITORY,
		label: '기숙사',
	},
	{
		value: Infrastructure.OTHER,
		label: '기타',
	},
];

export const BUSINESS_TYPE_OPTIONS = [
	{
		value: BusinessType.AGRICULTURAL,
		label: '농업',
	},
	{
		value: BusinessType.FISHING,
		label: '어업',
	},
];

export enum IsAllocationRestrictedEnum {
	APPLICABLE = '해당있음',
	NOT_APPLICABLE = '해당없음',
}

export const ALLOCATION_RESTRICTED_OPTIONS = [
	{
		value: 1,
		label: IsAllocationRestrictedEnum.APPLICABLE,
	},
	{
		value: 0,
		label: IsAllocationRestrictedEnum.NOT_APPLICABLE,
	},
];

export const AGRI_FRANCHISE_OPTIONS = [
	{
		value: AgriFranchiseEnum.AGRICULTURAL_BUSINESS_HOUSEHOLD,
		label: '농업 경영 가구',
	},
	{
		value: AgriFranchiseEnum.AGRICULTURAL_CORPORATION_ASSOCIATION,
		label: '농업법인·조합',
	},
	{
		value: AgriFranchiseEnum.AGRICULTURAL_PRODUCT_PROCESSING_COMPANY,
		label: '농산물가공업체',
	},
	{
		value: AgriFranchiseEnum.PUBLIC_FRANCHISE,
		label: '공공형 사업자',
	},
];

export const FISHERY_FRANCHISE_OPTIONS = [
	{
		value: FisheryFranchiseEnum.FISHING_OPERATION_HOUSEHOLD,
		label: '어업 운영가구',
	},
	{
		value: FisheryFranchiseEnum.FISHING_CORPORATION_ASSOCIATION,
		label: '어업조합·법인',
	},
	{
		value: FisheryFranchiseEnum.FISHING_PRODUCT_PROCESSING_COMPANY,
		label: '수산물가공업체',
	},
	// {
	// 	value: FisheryFranchiseEnum.PUBLIC_FRANCHISE,
	// 	label: '공공형 사업자',
	// },
];

export const dataAllContent = [
	{
		value: 'extension-of-stay',
		label: '체류연장',
	},
	{
		value: 'change-of-workplace',
		label: '근무처변경',
	},
	{
		value: 'leaving-without-notice',
		label: '무단이탈',
	},
];

export const dataBasicInfoApplicant = [
	{
		value: 'avatar',
		label: '이미지 영역',
	},
	{
		value: 'country',
		label: '읍/면',
	},
	{
		value: 'firstName',
		label: '성',
	},
	{
		value: 'lastName',
		label: '이름',
	},
	{
		value: 'birthDate',
		label: '생년월일',
	},
	{
		value: 'gender',
		label: '성별',
	},
	{
		value: 'height',
		label: '키',
	},
	{
		value: 'weight',
		label: '몸무게',
	},
	{
		value: 'phone',
		label: '전화번호',
	},
	{
		value: 'homeCountryAddress',
		label: '본국 주소',
	},
	{
		value: 'homePhoneNumber',
		label: '본국 전화번호',
	},
	{
		value: 'nationality',
		label: '국적',
	},
	{
		value: 'passport',
		label: '여권 번호',
	},
	{
		value: 'passportIssuanceDate',
		label: '여권 발급 일자',
	},
	{
		value: 'passportExpirationDate',
		label: '여권 만료 일자',
	},
	{
		value: 'applicantType',
		label: '지원 형태',
	},
	{
		value: 'publicType',
		label: '공공형',
	},
	{
		value: 'publicFranchise',
		label: '공공형 사업자 (농협)',
	},
	{
		value: 'rating',
		label: '등급',
	},
	{
		value: 'status',
		label: '상태',
	},
	{
		value: 'applicationStatus',
		label: '신청 상태',
	},
	{
		value: 'visaConfirmationNumber',
		label: '사증발급인정번호',
	},
	{
		value: 'visaAuthNumber',
		label: '사증인증번호',
	},
	{
		value: 'foreignerNumber',
		label: '외국인등록번호',
	},
	{
		value: 'entryDate',
		label: '입국 일자',
	},
	{
		value: 'departureDate',
		label: '출국 일자',
	},
	{
		value: 'residence',
		label: '체류자격',
	},
];

export const RELATIONSHIP_OPTIONS = [
	OPTION_SELECT,
	{
		value: RelationshipEnum.FAMILY,
		label: '가족·친척',
	},
	{
		value: RelationshipEnum.FRANCHISE,
		label: '고용주',
	},
	{
		value: RelationshipEnum.OTHER,
		label: '기타',
	},
];

export const DIVISION_RECOMMENDER_OPTIONS = [
	{
		value: DivisionRecommenderEnum.MARRIAGE_IMMIGRANT,
		label: '결혼 이민자',
	},
	{
		value: DivisionRecommenderEnum.OVERSEAS_LOCAL_GOVERNMENT,
		label: '해외 지자체',
	},
];

export const RESIDENCE_TYPE_OPTION = [
	{
		value: ResidenceTypeEnum.F_5,
		label: 'F-5',
	},
	{
		value: ResidenceTypeEnum.F_6,
		label: 'F-6',
	},
	{
		value: ResidenceTypeEnum.F_6_1,
		label: 'F-6-1',
	},
	{
		value: ResidenceTypeEnum.F_6_2,
		label: 'F-6-2',
	},
	{
		value: ResidenceTypeEnum.F_6_3,
		label: 'F-6-3',
	},
];

export enum AssignmentFranchiseTypeEnum {
	COMMON = 'COMMON',
	PUBLIC = 'PUBLIC',
}

export const ASSIGNMENT_FRANCHISE_TYPE_OPTIONS = [
	{
		value: AssignmentFranchiseTypeEnum.COMMON,
		label: '일반(농가)',
	},
	{
		value: AssignmentFranchiseTypeEnum.PUBLIC,
		label: '공공형',
	},
];

export const APPLICANT_PUBLIC_TYPE_OPTIONS = [
	{
		value: 0,
		label: '일반',
	},
	{
		value: 1,
		label: '공공형',
	},
];

export enum AssignmentStatusEnum {
	ASSIGNMENT_ALL = 'ASSIGNMENT_ALL',
	ASSIGNMENT_POSSIBLE = 'ASSIGNMENT_POSSIBLE',
}

export const ASSIGNMENT_STATUS_OPTIONS = [
	{
		label: '전체',
		value: AssignmentStatusEnum.ASSIGNMENT_ALL,
	},
	{
		label: '배정가능',
		value: AssignmentStatusEnum.ASSIGNMENT_POSSIBLE,
	},
];

export enum AssignmentApplicantStatusEnum {
	ASSIGNMENT_1 = 'ASSIGNMENT_1',
	ASSIGNMENT_2 = 'ASSIGNMENT_2',
	ASSIGNMENT_3 = 'ASSIGNMENT_3',
	ASSIGNMENT_4 = 'ASSIGNMENT_4',
	ASSIGNMENT_5 = 'ASSIGNMENT_5',
	ASSIGNMENT_6 = 'ASSIGNMENT_6',
	ASSIGNMENT_7 = 'ASSIGNMENT_7',
	// TODO: wait for api
}

export enum AllocationMethodEnum {
	NO_ASSIGNMENT = 'NO_ASSIGNMENT',
	AUTOMATIC_ASSIGNMENT = 'AUTOMATIC_ASSIGNMENT',
	MANUAL_ASSIGNMENT = 'MANUAL_ASSIGN',
}

export const ALLOCATION_METHOD_OPTIONS = [
	{
		label: '배정안함',
		value: AllocationMethodEnum.NO_ASSIGNMENT,
	},
	{
		label: '자동배정',
		value: AllocationMethodEnum.AUTOMATIC_ASSIGNMENT,
	},
	{
		label: '수동배정',
		value: AllocationMethodEnum.MANUAL_ASSIGNMENT,
	},
];

export enum AssignmentSettingUsedEnum {
	USED = 'USED',
	NOT_USED = 'NOT_USED',
}

export const ASSIGNMENT_SETTING_USED_OPTIONS = [
	{
		label: '사용',
		value: AssignmentSettingUsedEnum.USED,
	},
	{
		label: '미사용',
		value: AssignmentSettingUsedEnum.NOT_USED,
	},
];

export enum RangeAgeEnum {
	AGE_10 = 'AGE_10',
	AGE_20 = 'AGE_20',
	AGE_30 = 'AGE_30',
	AGE_40 = 'AGE_40',
	AGE_50 = 'AGE_50',
}

export const RANGE_AGE_OPTIONS = [
	{
		value: RangeAgeEnum.AGE_10,
		label: '10대',
	},
	{
		value: RangeAgeEnum.AGE_20,
		label: '20대',
	},
	{
		value: RangeAgeEnum.AGE_30,
		label: '30대',
	},
	{
		value: RangeAgeEnum.AGE_40,
		label: '40대',
	},
	{
		value: RangeAgeEnum.AGE_50,
		label: '50대 이상',
	},
];

export enum SettingUnitMasterInfoFieldTypeEnum {
	TEXT = 'TEXT',
	DATE = 'DATE',
}
export enum SettingUnitMasterInfoFieldTypeLabelEnum {
	TEXT = '텍스트',
	DATE = '날짜',
}

export enum SettingUnitMasterInfoObjectEnum {
	FRANCHISE = 'FRANCHISE',
	APPLICANT = 'APPLICANT',
}

export enum SettingUnitMasterInfoStatusEnum {
	STATUS = 'STATUS',
	ISSUANCE_APPLICATION_STATUS = 'ISSUANCE_APPLICATION_STATUS',
}

export enum TypeUpdateSettingMasterInfoEnum {
	DISTRICT = 'DISTRICT',
	STATUS = 'STATUS',
	ISSUANCE_STATUS = 'ISSUANCE_STATUS',
	APPLICANT_OPTIONAL_FIELD = 'APPLICANT_OPTIONAL_FIELD',
	FRANCHISE_OPTIONAL_FIELD = 'FRANCHISE_OPTIONAL_FIELD',
}

export type TUploadExcelPage = Extract<
	| PageTypeEnum.APPLICANT
	| PageTypeEnum.FRANCHISE
	| PageTypeEnum.ASSIGNMENT
	| PageTypeEnum.RECOMMENDER
	| PageTypeEnum.LODGING
	| PageTypeEnum.PUBLIC_ASSIGNMENT,
	PageTypeEnum
>;

export enum ExtensionStayEnum {
	ONE_MONTH = 'ONE_MONTH',
	TWO_MONTHS = 'TWO_MONTHS',
	THREE_MONTHS = 'THREE_MONTHS',
	FOUR_MONTHS = 'FOUR_MONTHS',
	FIVE_MONTHS = 'FIVE_MONTHS',
}

export const ExtensionStayLabel = {
	[ExtensionStayEnum.ONE_MONTH]: '1개월',
	[ExtensionStayEnum.TWO_MONTHS]: '2개월',
	[ExtensionStayEnum.THREE_MONTHS]: '3개월',
	[ExtensionStayEnum.FOUR_MONTHS]: '4개월',
	[ExtensionStayEnum.FIVE_MONTHS]: '5개월',
} as Record<ExtensionStayEnum, string>;

export const EXTEND_STAY_OPTIONS = [
	{
		value: '',
		label: 'common:select',
	},
	{
		value: ExtensionStayEnum.ONE_MONTH,
		label: 'common:one-month',
	},
	{
		value: ExtensionStayEnum.TWO_MONTHS,
		label: 'common:two-months',
	},
	{
		value: ExtensionStayEnum.THREE_MONTHS,
		label: 'common:three-months',
	},
	{
		value: ExtensionStayEnum.FOUR_MONTHS,
		label: 'common:four-months',
	},
	{
		value: ExtensionStayEnum.FIVE_MONTHS,
		label: 'common:five-months',
	},
];

export const EXTEND_STAY_OPTIONS_V2 = [
	{
		value: ExtensionStayEnum.ONE_MONTH,
		label: 'common:one-month',
	},
	{
		value: ExtensionStayEnum.TWO_MONTHS,
		label: 'common:two-months',
	},
	{
		value: ExtensionStayEnum.THREE_MONTHS,
		label: 'common:three-months',
	},
	{
		value: ExtensionStayEnum.FOUR_MONTHS,
		label: 'common:four-months',
	},
	{
		value: ExtensionStayEnum.FIVE_MONTHS,
		label: 'common:five-months',
	},
];

export enum VisaTimeEnum {
	DAY_90 = 'D_90',
	MONTH_8 = 'M_8',
	MONTH_7 = 'M_7',
	MONTH_6 = 'M_6',
	MONTH_5 = 'M_5',
	MONTH_4 = 'M_4',
	MONTH_3 = 'M_3',
}

export const VisaTimeLabel = {
	[VisaTimeEnum.MONTH_8]: '8개월',
	[VisaTimeEnum.MONTH_7]: '7개월',
	[VisaTimeEnum.MONTH_6]: '6개월',
	[VisaTimeEnum.MONTH_5]: '5개월',
	[VisaTimeEnum.MONTH_4]: '4개월',
	[VisaTimeEnum.MONTH_3]: '3개월',
	[VisaTimeEnum.DAY_90]: '90일',
};

export const VISA_TIME_E8_OPTIONS = [
	{
		value: VisaTimeEnum.MONTH_8,
		label: 'eight-months',
	},
	{
		value: VisaTimeEnum.MONTH_7,
		label: 'seven-months',
	},
	{
		value: VisaTimeEnum.MONTH_6,
		label: 'six-months',
	},
	{
		value: VisaTimeEnum.MONTH_5,
		label: 'five-months',
	},
	{
		value: VisaTimeEnum.MONTH_4,
		label: 'four-months',
	},
	{
		value: VisaTimeEnum.MONTH_3,
		label: 'three-months',
	},
];

export const VISA_TIME_C4_OPTIONS = [
	{
		value: VisaTimeEnum.DAY_90,
		label: 'ninety-days',
	},
];

export const VISA_TIME_OPTIONS = [
	{
		value: '',
		label: 'select',
	},
	...VISA_TIME_E8_OPTIONS,
	...VISA_TIME_C4_OPTIONS,
];

export enum CommonYearRegisterListEnum {
	UM1 = 'UM1',
	PM1 = 'PM1',
	CM1 = 'CM1',
	OM1 = 'OM1',
	OM2 = 'OM2',
	MM1 = 'MM1',
	NP1 = 'NP1',
	QP1 = 'QP1',
	RM1 = 'RM1',
}

export enum PageYearListEnum {
	BM1 = 'BM1',
	EM1 = 'EM1',
	PP1 = 'PP1',
	PM1_PROGRAM = 'PM1_PROGRAM',
}

export enum DocumentObjectListRefTableEnum {
	APPLICANT = 'APPLICANT',
	FRANCHISE = 'FRANCHISE',
	RECOMMENDER = 'RECOMMENDER',
	LODGING = 'LODGING',
	PROGRAM = 'PROGRAM',
}

export enum DocumentObjectListSearchTypeEnum {
	APPLICANT = 'APPLICANT',
	APPLICANT_DOB = 'APPLICANT_DOB',
	FRANCHISE = 'FRANCHISE',
	FRANCHISE_ADDRESS = 'FRANCHISE_ADDRESS',
	RECOMMENDER = 'RECOMMENDER',
	LODGING = 'LODGING',
	PROGRAM = 'PROGRAM',
}

//TODO: confirm with BE
export enum LodgingProviderTypeEnum {
	EMPLOYER = 'EMPLOYER',
	RECOMMENDER = 'RECOMMENDER',
	OTHER = 'OTHER',
	ID = 'ID',
	ADDRESS = 'ADDRESS',
	DISTRICT_NAME = 'DISTRICT_NAME',
	PROVIDER_NAME = 'PROVIDER_NAME',
}

export const LODGING_OPTIONS = [
	{
		value: LodgingProviderTypeEnum.ID,
		label: 'ID',
	},
	{
		value: LodgingProviderTypeEnum.DISTRICT_NAME,
		label: '읍/면',
		type: MasterInfoEnum.DISTRICT,
	},
	{
		value: LodgingProviderTypeEnum.ADDRESS,
		label: '숙소 주소',
		type: MasterInfoEnum.AUTOCOMPLETE_ADDRESS,
	},
	{
		value: LodgingProviderTypeEnum.PROVIDER_NAME,
		label: '제공자',
	},
];

export const LODGING_PROVIDER_TYPE_OPTIONS = [
	{ value: LodgingProviderTypeEnum.EMPLOYER, label: '고용주' },
	{ value: LodgingProviderTypeEnum.RECOMMENDER, label: '추천자' },
	{ value: LodgingProviderTypeEnum.OTHER, label: '기타' },
];

export enum GradeSalaryEnum {
	GRADE_A = '15,000',
	GRADE_B = '12,500',
	GRADE_C = '10,00',
}

//d-WC1-1
export enum ReasonTypeEnum {
	TERMINATION = 'TERMINATION',
	DEATH = 'DEATH',
	ABSENT_WITHOUT_PERMISSION = 'ABSENT_WITHOUT_PERMISSION',
	WORKPLACE_INFO_CHANGE = 'WORKPLACE_INFO_CHANGE',
	EMPLOYMENT_SUCCESSOR = 'EMPLOYMENT_SUCCESSOR',
	BRANCH_TRANSFER = 'BRANCH_TRANSFER',
	WORKER_DEPLOYMENT = 'WORKER_DEPLOYMENT',
	OTHER = 'OTHER',
}

export const ReasonLabel = {
	[ReasonTypeEnum.TERMINATION]:
		'근로계약 해지(해고, 퇴직, 계약기간 변경 등 포함)',
	[ReasonTypeEnum.DEATH]: '사망',
	[ReasonTypeEnum.WORKPLACE_INFO_CHANGE]:
		'고용사업장 정보변동(대표자, 명칭, 소재지 등 변경)',
	[ReasonTypeEnum.EMPLOYMENT_SUCCESSOR]: '고용승계(사업장 양수ㆍ양도)',
	[ReasonTypeEnum.BRANCH_TRANSFER]: '지사간 이동(고용주 변동이 없는 경우)',
	[ReasonTypeEnum.WORKER_DEPLOYMENT]:
		'근로자를 파견한 경우(파견사업장이 변경된 경우 포함)',
	[ReasonTypeEnum.OTHER]: '기타',
};

export const OPTIONS_REASON = Object.entries(ReasonLabel).map(
	([key, value]) => ({
		value: key,
		label: value,
	})
);

export const ReasonIndex = {
	[ReasonTypeEnum.TERMINATION]: 'a',
	[ReasonTypeEnum.DEATH]: 'b',
	[ReasonTypeEnum.ABSENT_WITHOUT_PERMISSION]: 'c',
	[ReasonTypeEnum.WORKPLACE_INFO_CHANGE]: 'd',
	[ReasonTypeEnum.EMPLOYMENT_SUCCESSOR]: 'e',
	[ReasonTypeEnum.BRANCH_TRANSFER]: 'f',
	[ReasonTypeEnum.WORKER_DEPLOYMENT]: 'g',
	[ReasonTypeEnum.OTHER]: 'h',
};

//d-wc1-2
export enum ReasonDetailTypeEnum {
	CONTRACT_EXPIRATION = 'CONTRACT_EXPIRATION',
	MUTUAL_AGREEMENT = 'MUTUAL_AGREEMENT',
	STRIKE = 'STRIKE',
	ABSENCE_WITHOUT_LEAVE = 'ABSENCE_WITHOUT_LEAVE',
	WORKER_FAULT = 'WORKER_FAULT',
	LONG_TERM_CLOSURE_OR_BANKRUPTCY = 'LONG_TERM_CLOSURE_OR_BANKRUPTCY',
	MANAGEMENT_NEEDS = 'MANAGEMENT_NEEDS',
	CONSTRUCTION_COMPLETION = 'CONSTRUCTION_COMPLETION',
	WAGE_ARREARS = 'WAGE_ARREARS',
	ABUSE_OR_HARASSMENT = 'ABUSE_OR_HARASSMENT',
	PERMIT_REVOCATION = 'PERMIT_REVOCATION',
	EMPLOYMENT_RESTRICTION = 'EMPLOYMENT_RESTRICTION',
	CONTRACT_DISCREPANCY = 'CONTRACT_DISCREPANCY',
	CONTRACT_VIOLATION = 'CONTRACT_VIOLATION',
	OTHER = 'OTHER',
	INJURY_OR_ILLNESS = 'INJURY_OR_ILLNESS',
	CULTURAL_OR_RELIGIOUS = 'CULTURAL_OR_RELIGIOUS',
}

export const ReasonDetailLabel = {
	[ReasonDetailTypeEnum.CONTRACT_EXPIRATION]: '계약기간 만료',
	[ReasonDetailTypeEnum.MUTUAL_AGREEMENT]:
		'당사자간 자율 합의로 근로계약 해지 또는 계약기간 변경',
	[ReasonDetailTypeEnum.STRIKE]:
		'근로자 태업으로 인한 근로계약 해지 또는 계약기간 변경',
	[ReasonDetailTypeEnum.ABSENCE_WITHOUT_LEAVE]:
		'근로자 무단결근으로 인한 근로계약 해지 또는 계약기간 변경',
	[ReasonDetailTypeEnum.WORKER_FAULT]:
		'기타 근로자 귀책으로 인한 근로계약 해지 또는 계약기간 변경',
	[ReasonDetailTypeEnum.LONG_TERM_CLOSURE_OR_BANKRUPTCY]:
		'장기간 휴업/휴직, 폐업/도산의 확정',
	[ReasonDetailTypeEnum.MANAGEMENT_NEEDS]: '경영상 필요에 의한 해고',
	[ReasonDetailTypeEnum.CONSTRUCTION_COMPLETION]: '공사종료',
	[ReasonDetailTypeEnum.WAGE_ARREARS]: '임금 체불 또는 지급 지연',
	[ReasonDetailTypeEnum.ABUSE_OR_HARASSMENT]:
		'폭행, 상습적 폭언, 성희롱, 성폭행 등',
	[ReasonDetailTypeEnum.PERMIT_REVOCATION]: '사업장의 고용허가 취소',
	[ReasonDetailTypeEnum.EMPLOYMENT_RESTRICTION]: '사업장의 외국인 고용 제한',
	[ReasonDetailTypeEnum.CONTRACT_DISCREPANCY]:
		'근로조건이 근로계약 조건과 상이',
	[ReasonDetailTypeEnum.CONTRACT_VIOLATION]: '근로조건 위반',
	[ReasonDetailTypeEnum.OTHER]: '기타',
	[ReasonDetailTypeEnum.INJURY_OR_ILLNESS]: '상해 등',
	[ReasonDetailTypeEnum.CULTURAL_OR_RELIGIOUS]: '종교적 문화의 특수성',
};

export const OPTIONS_DETAIL_REASON = Object.entries(ReasonDetailLabel).map(
	([key, value]) => ({
		value: key,
		label: value,
	})
);

export const ReasonDetailIndex = {
	[ReasonDetailTypeEnum.CONTRACT_EXPIRATION]: '1',
	[ReasonDetailTypeEnum.MUTUAL_AGREEMENT]: '2',
	[ReasonDetailTypeEnum.STRIKE]: '3',
	[ReasonDetailTypeEnum.ABSENCE_WITHOUT_LEAVE]: '4',
	[ReasonDetailTypeEnum.WORKER_FAULT]: '5',
	[ReasonDetailTypeEnum.LONG_TERM_CLOSURE_OR_BANKRUPTCY]: '6',
	[ReasonDetailTypeEnum.MANAGEMENT_NEEDS]: '7',
	[ReasonDetailTypeEnum.CONSTRUCTION_COMPLETION]: '8',
	[ReasonDetailTypeEnum.WAGE_ARREARS]: '9',
	[ReasonDetailTypeEnum.ABUSE_OR_HARASSMENT]: '10',
	[ReasonDetailTypeEnum.PERMIT_REVOCATION]: '11',
	[ReasonDetailTypeEnum.EMPLOYMENT_RESTRICTION]: '12',
	[ReasonDetailTypeEnum.CONTRACT_DISCREPANCY]: '13',
	[ReasonDetailTypeEnum.CONTRACT_VIOLATION]: '14',
	[ReasonDetailTypeEnum.OTHER]: '15',
	[ReasonDetailTypeEnum.INJURY_OR_ILLNESS]: '16',
	[ReasonDetailTypeEnum.CULTURAL_OR_RELIGIOUS]: '17',
};

export enum EOccuringAreaEnum {
	BUSINESS_PLACE = 'BUSINESS_PLACE',
	ACCOMMODATION = 'ACCOMMODATION',
	OTHER = 'OTHER',
}
export const OCCURING_AREA_OPTIONS = [
	{
		value: EOccuringAreaEnum.BUSINESS_PLACE,
		label: '사업장',
	},
	{
		value: EOccuringAreaEnum.ACCOMMODATION,
		label: '숙소',
	},
	{
		value: EOccuringAreaEnum.OTHER,
		label: '기타',
	},
];

export enum ETypeRequestInquiryType {
	FUNCTIONAL_ERROR = 'FUNCTIONAL_ERROR',
	FEATURE_ADDITION = 'FEATURE_ADDITION',
	OTHER = 'OTHER',
}

export enum EStatusInquiryType {
	WAIT_REPLY = 'WAIT_REPLY',
	REPLIED = 'REPLIED',
}

export const INQUIRY_TYPE_OPTIONS = [
	{
		value: ETypeRequestInquiryType.FUNCTIONAL_ERROR,
		label: 'inquiry-type.feature-error',
	},
	{
		value: ETypeRequestInquiryType.FEATURE_ADDITION,
		label: 'inquiry-type.feature-request',
	},
	{
		value: ETypeRequestInquiryType.OTHER,
		label: 'inquiry-type.others',
	},
];

export const INQUIRY_STATUS_OPTIONS = [
	{
		value: EStatusInquiryType.WAIT_REPLY,
		label: 'inquiry-status.wait-reply',
	},
	{
		value: EStatusInquiryType.REPLIED,
		label: 'inquiry-status.replied',
	},
];

export enum EDeviceEnum {
	APPLICANT = 'APPLICANT',
	FRANCHISE = 'FRANCHISE',
	DOMESTIC = 'DOMESTIC',
	FOREIGN = 'FOREIGN',
}

export const INQUIRER_TYPE_OPTIONS = [
	{
		value: EDeviceEnum.APPLICANT,
		label: 'inquirer-type.worker',
	},
	{
		value: EDeviceEnum.FRANCHISE,
		label: 'inquirer-type.business',
	},
	{
		value: EDeviceEnum.DOMESTIC,
		label: 'inquirer-type.domestic',
	},
	{
		value: EDeviceEnum.FOREIGN,
		label: 'inquirer-type.foreign',
	},
];

export enum ETypeSearchWorkChangePlace {
	EMPLOYER_NAME = 'EMPLOYER_NAME',
	FRANCHISE_ADDRESS = 'FRANCHISE_ADDRESS',
	APPLICANT = 'APPLICANT',
}

export const TYPE_SEARCH_WORK_CHANGE_PLACE_OPTIONS = [
	{
		value: ETypeSearchWorkChangePlace.EMPLOYER_NAME,
		label: '고용주',
		type: MasterInfoEnum.AUTOCOMPLETE_FRANCHISE,
	},
	{
		value: ETypeSearchWorkChangePlace.FRANCHISE_ADDRESS,
		label: '사업장 주소',
	},
];

export enum ETypeSearchCommonFranchise {
	RECRUITER_NAME = 'RECRUITER_NAME',
	FRANCHISE_NAME = 'FRANCHISE_NAME',
}

export const TYPE_SEARCH_COMMON_FRANCHISE_OPTIONS = [
	{
		value: ETypeSearchCommonFranchise.RECRUITER_NAME,
		label: '고용주',
		type: MasterInfoEnum.AUTOCOMPLETE_FRANCHISE,
	},
	{
		value: ETypeSearchCommonFranchise.FRANCHISE_NAME,
		label: '사업장',
		type: MasterInfoEnum.AUTOCOMPLETE_FRANCHISE_NAME,
	},
];

export enum PageTypeEnumSelectLodging {
	FRANCHISE = 'FRANCHISE',
	APPLICANT = 'APPLICANT',
	RECOMMENDER = 'RECOMMENDER',
}

export const PAGE_TYPE_ENUM_SELECT_LODGING_MAP = {
	[PageTypeEnumSelectLodging.FRANCHISE]: '고용주',
	[PageTypeEnumSelectLodging.APPLICANT]: '근로자',
	[PageTypeEnumSelectLodging.RECOMMENDER]: '추천자',
};

export enum EDashboardStatisticEnum {
	ASSIGNMENT_FRANCHISE = 'ASSIGNMENT_FRANCHISE',
	ASSIGNMENT_APPLICANT = 'ASSIGNMENT_APPLICANT',
	APPLICANT_NON_ISSUANCE_FOREIGN = 'APPLICANT_NON_ISSUANCE_FOREIGN',
	APPLICANT_DEPARTURE = 'APPLICANT_DEPARTURE',
	APPLICANT_UNAUTHORIZED_DEPARTURE = 'APPLICANT_UNAUTHORIZED_DEPARTURE',
	APPLICANT_CHANGE_WORKPLACE = 'APPLICANT_CHANGE_WORKPLACE',
	APPLICATION_TYPE_MOU = 'APPLICATION_TYPE_MOU',
	APPLICATION_TYPE_FAMILY = 'APPLICATION_TYPE_FAMILY',
	APPLICATION_TYPE_OTHER = 'APPLICATION_TYPE_OTHER',
	APPLICATION_TYPE_DOMESTIC_STAY = 'APPLICATION_TYPE_DOMESTIC_STAY',
	DISTRICT_ID = 'DISTRICT_ID',
	APPLICATION_TYPE_PUBLIC = 'APPLICATION_TYPE_PUBLIC',
	DISTRICT_NULL = 'DISTRICT_NULL',
	APPLICANT_OTHER = 'APPLICANT_OTHER',
	APPLICANT_TYPE_NOT_PUBLIC = 'APPLICANT_TYPE_NOT_PUBLIC',
	APPLICANT_TYPE_D2_STUDENT_PARENT_INVITATION = 'APPLICANT_TYPE_D2_STUDENT_PARENT_INVITATION',
}

export const MAX_LENGTH_DETAIL_TITLE = 30;

export enum CaroEnum {
	X = 'X',
	O = 'O',
}

export const CARO_OPTIONS: any = [
	{ value: 0, label: CaroEnum.X },
	{ value: 1, label: CaroEnum.O },
];

export const CARO_BOOLEAN_OPTIONS: any = [
	{ value: false, label: CaroEnum.X },
	{ value: true, label: CaroEnum.O },
];

export enum ReEntryRecommendationStatusEnum {
	NOT_ELIGIBLE = 'NOT_ELIGIBLE',
	ELIGIBLE_75_PERCENT_STAY = 'ELIGIBLE_75_PERCENT_STAY',
	ELIGIBLE_CONTRACT_COMPLETED = 'ELIGIBLE_CONTRACT_COMPLETED',
}

export const RE_ENTRY_RECOMMENDATION_STATUS_OPTIONS = [
	{
		value: ReEntryRecommendationStatusEnum.NOT_ELIGIBLE,
		label: '미대상',
	},
	{
		value: ReEntryRecommendationStatusEnum.ELIGIBLE_75_PERCENT_STAY,
		label: '대상(75% 체류)',
	},
	{
		value: ReEntryRecommendationStatusEnum.ELIGIBLE_CONTRACT_COMPLETED,
		label: '대상(계약기간 이행 완료)',
	},
];

export const UPDATE_FIELD_IS_NULL_OPTIONS = [
	'PUBLIC_FRANCHISE_ID',
	'TYPE_DETAIL',
	'VISA_CODE',
];

export const APP_VERSION = process.env.REACT_APP_VERSION;

export const YES_NO_OPTIONS = [
	{ value: 1, label: 'O' },
	{ value: 0, label: 'X' },
];

export const ON_OFF_OPTIONS = [
	{ value: 1, label: 'ON' },
	{ value: true, label: 'ON' },
	{ value: 'true', label: 'ON' },
	{ value: 0, label: 'OFF' },
	{ value: false, label: 'OFF' },
	{ value: 'false', label: 'OFF' },
];

export const panelStyle: React.CSSProperties = {
	background: '#fff',
	borderBottom: '2.222vw solid #eeeeee',
};

export const WORKFORCE_RANGES = {
	//AGRICULTURE
	[ProductionTypeEnum.HORTICULTURE_SPECIAL_CROPS]: [
		{ min: -Infinity, max: 2.6, workforce: 5 },
		{ min: 2.6, max: 3.9, workforce: 6 },
		{ min: 3.9, max: 5.2, workforce: 7 },
		{ min: 5.2, max: 6.5, workforce: 8 },
		{ min: 6.5, max: Infinity, workforce: 9 },
	],
	[ProductionTypeEnum.MUSHROOMS]: [
		{ min: -Infinity, max: 5.2, workforce: 5 },
		{ min: 5.2, max: 7.8, workforce: 6 },
		{ min: 7.8, max: 10.4, workforce: 7 },
		{ min: 10.4, max: 13, workforce: 8 },
		{ min: 13, max: Infinity, workforce: 9 },
	],
	[ProductionTypeEnum.FRUITS]: [
		{ min: -Infinity, max: 16, workforce: 5 },
		{ min: 16, max: 24, workforce: 6 },
		{ min: 24, max: 32, workforce: 7 },
		{ min: 32, max: 38, workforce: 8 },
		{ min: 38, max: Infinity, workforce: 9 },
	],
	[ProductionTypeEnum.GINSENG_AND_GENERAL_VEGETABLES]: [
		{ min: -Infinity, max: 12, workforce: 5 },
		{ min: 12, max: 18, workforce: 6 },
		{ min: 18, max: 24, workforce: 7 },
		{ min: 24, max: 30, workforce: 8 },
		{ min: 30, max: Infinity, workforce: 9 },
	],
	[ProductionTypeEnum.BEAN_SPROUTS_AND_SEEDLING_CULTIVATION]: [
		{ min: -Infinity, max: 0.35, workforce: 5 },
		{ min: 0.35, max: 0.65, workforce: 6 },
		{ min: 0.65, max: 0.95, workforce: 7 },
		{ min: 0.95, max: 1.25, workforce: 8 },
		{ min: 1.25, max: Infinity, workforce: 9 },
	],
	[ProductionTypeEnum.OTHER_HORTICULTURE_SPECIAL_CROPS]: [
		{ min: -Infinity, max: 7.8, workforce: 5 },
		{ min: 7.8, max: 11.7, workforce: 6 },
		{ min: 11.7, max: 15.6, workforce: 7 },
		{ min: 15.6, max: 19.5, workforce: 8 },
		{ min: 19.5, max: Infinity, workforce: 9 },
	],
	[ProductionTypeEnum.GRAINS]: [
		{ min: -Infinity, max: 50, workforce: 5 },
		{ min: 50, max: 300, workforce: 6 },
		{ min: 300, max: 400, workforce: 7 },
		{ min: 400, max: 500, workforce: 8 },
		{ min: 500, max: Infinity, workforce: 9 },
	],
	[ProductionTypeEnum.OTHER_FOOD_CROPS]: [
		{ min: -Infinity, max: 7, workforce: 5 },
		{ min: 7, max: 10, workforce: 6 },
		{ min: 10, max: 13, workforce: 7 },
		{ min: 13, max: 16, workforce: 8 },
		{ min: 16, max: Infinity, workforce: 9 },
	],
	[ProductionTypeEnum.DRIED_PERSIMMON_PROCESSING]: [
		{ min: -Infinity, max: 70 / 1000, workforce: 5 },
		{ min: 70 / 1000, max: 80 / 1000, workforce: 6 },
		{ min: 80 / 1000, max: 90 / 1000, workforce: 7 },
		{ min: 90 / 1000, max: 100 / 1000, workforce: 8 },
		{ min: 100 / 1000, max: Infinity, workforce: 9 },
	],
	//FISHING
	[ProductionTypeEnum.SEAWEED_DRY_LAVER]: [
		{ min: -Infinity, max: 30, workforce: 5 },
		{ min: 30, max: 50, workforce: 6 },
		{ min: 50, max: 60, workforce: 7 },
		{ min: 60, max: 70, workforce: 8 },
		{ min: 70, max: Infinity, workforce: 9 },
	],
	[ProductionTypeEnum.SEAWEED_OTHER]: [
		{ min: -Infinity, max: 0.5, workforce: 5 },
		{ min: 0.5, max: 0.8, workforce: 6 },
		{ min: 0.8, max: 1, workforce: 7 },
		{ min: 1, max: 1.2, workforce: 8 },
		{ min: 1.2, max: Infinity, workforce: 9 },
	],
	[ProductionTypeEnum.SEAWEED_AQUACULTURE]: [
		{ min: -Infinity, max: Infinity, workforce: 5 },
	],
	[ProductionTypeEnum.SHELLFISH_DRY_ANCHOVIES]: [
		{ min: -Infinity, max: 8, workforce: 5 },
		{ min: 8, max: 12, workforce: 6 },
		{ min: 12, max: 16, workforce: 7 },
		{ min: 16, max: 20, workforce: 8 },
		{ min: 20, max: Infinity, workforce: 9 },
	],
	[ProductionTypeEnum.SHELLFISH_OTHER]: [
		{ min: -Infinity, max: 0.0012, workforce: 5 },
		{ min: 0.0012, max: 0.002, workforce: 6 },
		{ min: 0.002, max: 0.003, workforce: 7 },
		{ min: 0.003, max: 0.004, workforce: 8 },
		{ min: 0.004, max: Infinity, workforce: 9 },
	],
	[ProductionTypeEnum.SHELLFISH_ABALONE_SEED]: [
		{ min: -Infinity, max: 300, workforce: 5 },
		{ min: 300, max: 350, workforce: 6 },
		{ min: 350, max: 400, workforce: 7 },
		{ min: 400, max: 450, workforce: 8 },
		{ min: 450, max: Infinity, workforce: 9 },
	],
	[ProductionTypeEnum.SHELLFISH_AQUACULTURE]: [
		{ min: -Infinity, max: Infinity, workforce: 2 },
	],
	[ProductionTypeEnum.TUNICATES_AQUACULTURE]: [
		{ min: -Infinity, max: Infinity, workforce: 2 },
	],
};

export const PRODUCTION_UNIT_JSON = {
	//AGRICULTURE
	[ProductionTypeEnum.HORTICULTURE_SPECIAL_CROPS]: '㎡',
	[ProductionTypeEnum.MUSHROOMS]: '㎡',
	[ProductionTypeEnum.FRUITS]: '㎡',
	[ProductionTypeEnum.GINSENG_AND_GENERAL_VEGETABLES]: '㎡',
	[ProductionTypeEnum.BEAN_SPROUTS_AND_SEEDLING_CULTIVATION]: '㎡',
	[ProductionTypeEnum.OTHER_HORTICULTURE_SPECIAL_CROPS]: '㎡',
	[ProductionTypeEnum.GRAINS]: '㎡',
	[ProductionTypeEnum.OTHER_FOOD_CROPS]: '㎡',
	[ProductionTypeEnum.DRIED_PERSIMMON_PROCESSING]: '접',

	//FISHING
	[ProductionTypeEnum.SEAWEED_DRY_LAVER]: '속',
	[ProductionTypeEnum.SEAWEED_OTHER]: '톤',
	[ProductionTypeEnum.SEAWEED_AQUACULTURE]: '톤',
	[ProductionTypeEnum.SHELLFISH_DRY_ANCHOVIES]: '박스',
	[ProductionTypeEnum.SHELLFISH_OTHER]: '톤',
	[ProductionTypeEnum.SHELLFISH_ABALONE_SEED]: '마리',
	[ProductionTypeEnum.SHELLFISH_AQUACULTURE]: '톤',
	[ProductionTypeEnum.TUNICATES_AQUACULTURE]: '톤',
};

export enum EAppTypeEnum {
	FRANCHISE = 'FRANCHISE',
	APPLICANT = 'APPLICANT',
	ALL = 'ALL',
}

export const APP_TYPE_OPTIONS = [
	{ value: EAppTypeEnum.APPLICANT, label: 'sms-options.worker' },
	{ value: EAppTypeEnum.FRANCHISE, label: 'sms-options.business' },
];

export enum AppProgramStatusEnum {
	REQUESTED = 'REQUESTED',
	APPROVED = 'APPROVED',
	REJECTED = 'REJECTED',
}

export const AppProgramStatusOptions = [
	{ value: AppProgramStatusEnum.REQUESTED, label: '심사중' },
	{ value: AppProgramStatusEnum.APPROVED, label: '프로그램 참여중' },
	{ value: AppProgramStatusEnum.REJECTED, label: '심사 반려' },
];

export const AppProgramLabel = {
	[AppProgramStatusEnum.REQUESTED]: '심사중',
	[AppProgramStatusEnum.APPROVED]: '프로그램 참여중',
	[AppProgramStatusEnum.REJECTED]: '심사 반려',
};

export enum AccountStatusEnum {
	WITHDRAWN = 1,
}

export const AccountStatusLabel = {
	[AccountStatusEnum.WITHDRAWN]: '탈퇴 요청',
};

export const ACCOUNT_STATUS_OPTIONS = [
	...Object.entries(AccountStatusLabel).map(([key, value]) => ({
		value: key,
		label: value,
	})),
];

export enum AreaRefTableNameEnum {
	UNIT = 'UNIT',
	APPLICANT = 'APPLICANT',
	FRANCHISE = 'FRANCHISE',
	LODGING = 'LODGING',
	RECOMMENDER = 'RECOMMENDER',
	WORK_CHANGE_PLACE = 'CHANGE_WORK_PLACE',
	UNAUTHORIZED_DEPARTURE = 'UNAUTHORIZED_DEPARTURE',
	ASSIGNMENT_FRANCHISE = 'ASSIGNMENT_FRANCHISE',
	FRANCHISE_PROGRAM = 'FRANCHISE_PROGRAM',
	PROGRAM = 'PROGRAM',
	OTHER = 'OTHER',
}

export enum EUpdateAreaEnum {
	BASIC_INFO = 'BASIC_INFO',
	DOCUMENT_INFO = 'DOCUMENT_INFO',
	NOTIFICATION_CONTROL = 'NOTIFICATION_CONTROL',
	NAME_PLATE_INFO = 'NAME_PLATE_INFO',
	SEAL_INFO = 'SEAL_INFO',
}

export const LIST_MENU_HISTORY = [
	{
		label: '근로자',
		value: AreaRefTableNameEnum.APPLICANT,
		refTableName: AreaRefTableNameEnum.APPLICANT,
	},
	{
		label: '사업장',
		value: AreaRefTableNameEnum.FRANCHISE,
		refTableName: AreaRefTableNameEnum.FRANCHISE,
	},
	{
		label: '추천자',
		value: AreaRefTableNameEnum.RECOMMENDER,
		refTableName: AreaRefTableNameEnum.RECOMMENDER,
	},
	{
		label: '숙소',
		value: AreaRefTableNameEnum.LODGING,
		refTableName: AreaRefTableNameEnum.LODGING,
	},
	{
		label: '배정',
		value: AreaRefTableNameEnum.ASSIGNMENT_FRANCHISE,
		refTableName: AreaRefTableNameEnum.FRANCHISE,
	},
	{
		label: '사업체',
		value: AreaRefTableNameEnum.UNIT,
		refTableName: AreaRefTableNameEnum.UNIT,
	},
	{
		label: '근무처 변경',
		value: AreaRefTableNameEnum.WORK_CHANGE_PLACE,
		refTableName: AreaRefTableNameEnum.FRANCHISE,
	},
	{
		label: '무단이탈',
		value: AreaRefTableNameEnum.UNAUTHORIZED_DEPARTURE,
		refTableName: AreaRefTableNameEnum.FRANCHISE,
	},
];

export enum MidTermDepartureEnum {
	HEALTH_ISSUE = '건강 문제',
	LOCAL_ADAPTATION_ISSUE = '현지 부적응',
	WORK_INCOMPETENCE = '업무 미숙, 태만',
	EMPLOYER_REASON = '고용주 측 사유',
	COUNTRY_SITUATION = '본국 사정 (가족사망, 긴급상황 등)',
	OTHER = '기타',
}

export const MID_TERM_DEPARTURE_OPTIONS = [
	{ value: '', label: '선택' },
	{ value: MidTermDepartureEnum.HEALTH_ISSUE, label: '건강 문제' },
	{
		value: MidTermDepartureEnum.LOCAL_ADAPTATION_ISSUE,
		label: '현지 부적응',
	},
	{
		value: MidTermDepartureEnum.WORK_INCOMPETENCE,
		label: '업무 미숙, 태만',
	},
	{
		value: MidTermDepartureEnum.EMPLOYER_REASON,
		label: '고용주 측 사유',
	},
	{
		value: MidTermDepartureEnum.COUNTRY_SITUATION,
		label: '본국 사정 (가족사망, 긴급상황 등)',
	},
	{ value: MidTermDepartureEnum.OTHER, label: '기타' },
];

export const RELAX_TIME_OPTIONS = [
	{ value: 0.5, label: '0.5' },
	{ value: 1, label: '1' },
	{ value: 1.5, label: '1.5' },
	{ value: 2, label: '2' },
	{ value: 2.5, label: '2.5' },
	{ value: 3, label: '3' },
	{ value: 3.5, label: '3.5' },
	{ value: 4, label: '4' },
];
